import React from 'react';
import type { CondicionesTienda } from '../types/metas.types';
import { CAMPOS_CONDICION, ETIQUETA_CONDICION, textoBonos } from '../utils/catalogo';

interface Props {
  condicion: CondicionesTienda;
  /**
   * Con qué se compara (lo que vale hoy o en la semana que se ve). Lo que
   * cambia se marca: el regional autoriza la DIFERENCIA, y tres «Sí/No»
   * sueltos no dicen qué bono se da de alta o se quita.
   */
  antes?: CondicionesTienda | null;
  /** Texto para lo de `antes` («hoy», «en la semana 39»). */
  etiquetaAntes?: string;
}

const siNo = (v: boolean) => (v ? 'Sí' : 'No');

/**
 * Las tres casillas de una tienda y los bonos que dan. Una lista, no una
 * tabla: cabe igual en teléfono y en escritorio sin arrastrar la página.
 */
export const CondicionesResumen: React.FC<Props> = ({ condicion, antes, etiquetaAntes = 'antes' }) => {
  const cambiaBonos = !!antes && textoBonos(antes) !== textoBonos(condicion);
  return (
    <div className="flex flex-col gap-1 text-sm" data-testid="condiciones-resumen">
      <ul className="flex flex-col gap-0.5">
        {CAMPOS_CONDICION.map((campo) => {
          const cambia = !!antes && antes[campo] !== condicion[campo];
          return (
            <li key={campo} className="flex flex-wrap items-baseline gap-x-2" data-cambia={cambia || undefined}>
              <span className="text-gray-600">{ETIQUETA_CONDICION[campo]}:</span>
              <strong className={cambia ? 'text-amber-800' : 'text-gray-800'}>{siNo(condicion[campo])}</strong>
              {cambia && antes && (
                <span className="text-xs text-amber-800">
                  ({etiquetaAntes}: {siNo(antes[campo])})
                </span>
              )}
            </li>
          );
        })}
      </ul>
      <div>
        <span className="text-gray-600">Bonos: </span>
        <strong>{textoBonos(condicion)}</strong>
        {cambiaBonos && antes && (
          <span className="text-xs text-amber-800">
            {' '}
            ({etiquetaAntes}: {textoBonos(antes)})
          </span>
        )}
      </div>
    </div>
  );
};

export default CondicionesResumen;
